<template>
  <div id="meda-sosial-page">
    <h6 class="m-t-0 m-b-20">
      <i class="bi bi-chat-text"></i> Topik
      <i
        class="bi bi-question-circle text-blue"
        v-tooltip.right="{ ref: 'topikHelper' }"
      ></i>
      <button
        v-if="isAdmin"
        id="tambah-topik"
        class="btn btn-success btn-icon-left pull-right"
        @click="addTopic"
      >
        <i class="bi bi-plus"></i> Tambah Topik
      </button>
    </h6>
    <div ref="topikHelper" class="tooltip-content">
      <p>
        <b>Topik</b> digunakan untuk mengelompokkan beberapa keyword menjadi
        satu.
      </p>
    </div>

    <div class="table-wrapper m-b-20">
      <table
        class="table table-hover table-condensed"
        id="daftar-topik"
        style="width: 100%"
      >
        <thead>
          <tr>
            <th width="50%">Topik</th>
            <th class="text-center">Jumlah Keyword</th>
            <th v-if="isAdmin" class="text-center">Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="is_loading_topik">
            <td :colspan="isAdmin ? 3 : 2" align="center">Loading...</td>
          </tr>
        </tbody>
      </table>
    </div>

    <h6 class="m-t-0 m-b-20">
      <i class="bi bi-key"></i> Keyword
      <i
        class="bi bi-question-circle text-blue"
        v-tooltip.right="{ ref: 'keywordHelper' }"
      ></i>
      <button
        v-if="isAdmin"
        id="tambah-keyword"
        class="btn btn-success btn-icon-left pull-right"
        @click="addKeyword"
        :disabled="
          project_detail && keyword_terpakai >= project_detail.keyword_limit
        "
      >
        <i class="bi bi-plus"></i> Tambah Keyword
      </button>
      <button
        id="export-keyword"
        class="btn btn-complete btn-icon-left pull-right mr-2"
        @click="exportKeyword"
      >
        <i class="bi bi-filetype-xlsx"></i> Ekspor Keyword
      </button>
      <button
        v-if="user_role == 1"
        id="copy-query"
        class="btn btn-warning btn-icon-left pull-right mr-2"
        @click="copyQuery"
      >
        <i :class="is_copied ? 'bi bi-clipboard-check' : 'bi bi-copy'"></i>
        {{ is_copied ? "Berhasil Disalin!" : "Salin Query" }}
      </button>
    </h6>
    <div ref="keywordHelper" class="tooltip-content">
      <p>
        <b>Keyword</b> merupakan kata kunci yang digunakan dalam pencarian data.
        Sistem akan memonitor postingan media konvensional yang mengandung kata
        kunci tersebut.
      </p>
      <p>
        Crawler Twitter, Facebook, Instagram, Youtube, Blog dan Forum akan
        menggunakan keyword ini.
      </p>
    </div>

    <div v-if="keyword_display" class="col-md-12 p-l-0 p-r-0 m-b-10">
      <p class="m-b-0 bold">
        Limit Keyword Media Sosial (Terpakai: {{ keyword_terpakai }})
      </p>
      <div class="progress m-b-0">
        <div
          :class="'progress-bar ' + keyword_display.class"
          :style="'width:' + keyword_display.persentase + '%'"
        ></div>
      </div>
      <span>0</span
      ><span v-if="project_detail" class="pull-right">{{
        project_detail.keyword_limit
      }}</span>
    </div>
    <div class="table-wrapper">
      <table
        class="table table-hover table-condensed"
        id="daftar-keyword"
        style="width: 100%"
      >
        <thead>
          <tr>
            <th>Topik</th>
            <th>Keyword</th>
            <th>Exclude</th>
            <th v-if="isAdmin" class="text-center">Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="is_loading_keyword">
            <td colspan="4" align="center">Loading...</td>
          </tr>
        </tbody>
      </table>
    </div>
    <modal-dynamic-component
      v-if="modal"
      :key="modal_key"
      :modal="modal"
      :data="modal.data"
      :static="true"
    />
    <v-tour
      v-if="tour_steps.length > 0"
      name="myTour"
      :steps="tour_steps"
      :options="{ highlight: true }"
    ></v-tour>
    <floating-loader-component v-if="is_loading_float" />
  </div>
</template>

<script>
import swal from "sweetalert";
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import floating_loader from "@/views/components/floating_loader.vue";
import modal_add_keyword from "@/views/components/settings/keyword/modal_add_keyword.vue";
import modal_add_topic from "@/views/components/settings/keyword/modal_add_topic.vue";
import modal_edit_keyword from "@/views/components/settings/keyword/modal_edit_keyword.vue";
import modal_edit_topic from "@/views/components/settings/keyword/modal_edit_topic.vue";
import modal_query_topic from "@/views/components/settings/keyword/modal_query_topic.vue";
import XLSX from "xlsx";

export default {
  name: "tab_media_sosial",
  props: {
    data: {
      type: Array,
      default: function() {
        return [];
      },
    },
  },
  components: {
    "modal-dynamic-component": modal_dynamic,
    "floating-loader-component": floating_loader,
  },
  data() {
    return {
      tour_steps: [],
      id_project:
        this.$store.getters.user.id_project != 0
          ? this.$store.getters.user.id_project
          : atob(this.$route.query.ref),
      is_loading_keyword: true,
      is_loading_topik: true,
      api: process.env.VUE_APP_API_URL,
      keywords: null,
      topics: [],
      table: null,
      table_topic: null,
      modal: null,
      modal_key: 0,
      is_loading_float: false,
      keyword_display: null,
      project_detail: null,
      user_role: this.$store.getters.user.role,
      is_copied: false,
    };
  },
  methods: {
    showCount: function(topic) {
      if (this.keywords) {
        const keyword = this.keywords.filter((el) => el.topic == topic);
        if (keyword) {
          return keyword.length;
        }
        return 0;
      }
      return 0;
    },
    addKeyword: function() {
      if (!this.modal) {
        this.modal = {
          title: "Tambah Keyword",
          subtitle:
            "Silahkan masukan kata kunci yang akan dimonitor dan kata yang akan dikecualikan",
          component: modal_add_keyword,
          data: [{ tipe: 1 }],
        };
      } else {
        this.modal = {
          title: "Tambah Keyword",
          subtitle:
            "Silahkan masukan kata kunci yang akan dimonitor dan kata yang akan dikecualikan",
          component: modal_add_keyword,
          data: [{ tipe: 1 }],
        };
        this.modal_key++;
      }
    },
    getKeyword: function() {
      this.is_loading_keyword = true;
      let api = this.api + "socmed-keywords/" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.keywords = response.data;
            this.generateTable("#daftar-keyword", this.keywords);
          } else {
            this.generateTable("#daftar-keyword", []);
          }
          this.getTopic();
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.is_loading_keyword = false;
        });
      this.getProjectDetail();
    },
    deletekeyword: function(topic_id, keyword) {
      let self = this;
      swal({
        title: "Apakah anda yakin?",
        text: "Akan menghapus keyword tersebut.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
      }).then((yess) => {
        if (yess) {
          let params = {
            _id: topic_id,
            keyword: keyword,
            tipe: 1,
          };
          let api = process.env.VUE_APP_API_URL + "new-keyword-delete";
          this.is_loading_float = true;
          this.$http
            .post(api, params)
            .then(function(response) {
              if (response.status == 200) {
                self.getProjectDetail();
                self.getKeyword();
                self
                  .$("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Keyword berhasil dihapus.',
                    position: "top",
                    timeout: 5000,
                    type: "success",
                  })
                  .show();
              }
            })
            .catch(function() {
              self
                .$("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat menghapus keyword.',
                  position: "top",
                  timeout: 5000,
                  type: "danger",
                })
                .show();
            })
            .finally(() => {
              this.is_loading_float = false;
            });
        }
      });
    },
    editKeyword: function(topic_id, data) {
      if (!this.modal) {
        let arr_data = [];
        arr_data["topic_id"] = data.topic_id;
        arr_data["keyword"] = data.keyword;
        arr_data["excludes"] = data.excludes;
        arr_data["tipe"] = 1;
        this.modal = {
          title: "Edit Keyword",
          subtitle:
            "Silahkan masukan kata kunci yang akan dimonitor dan kata yang akan dikecualikan",
          component: modal_edit_keyword,
          data: arr_data,
        };
      } else {
        let arr_data = [];
        arr_data["topic_id"] = data.topic_id;
        arr_data["keyword"] = data.keyword;
        arr_data["excludes"] = data.excludes;
        arr_data["tipe"] = 1;
        this.modal = {
          title: "Edit Keyword",
          subtitle:
            "Silahkan masukan kata kunci yang akan dimonitor dan kata yang akan dikecualikan",
          component: modal_edit_keyword,
          data: arr_data,
        };
        this.modal_key++;
      }
    },
    getTopic: function() {
      this.is_loading_topik = true;
      let api = this.api + "list-topics/" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.topics = response.data.socmed;
            this.generateTableTopic(
              "#daftar-topik",
              Object.entries(this.topics)
            );
          } else if (response.status == 204) {
            this.topics = {};
            this.generateTableTopic(
              "#daftar-topik",
              Object.entries(this.topics)
            );
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.is_loading_topik = false;
        });
    },
    editTopic: function(table_data) {
      let data = [];
      data["topic"] = this.topics[table_data[0]];
      data["id_topic"] = table_data[0];
      data["tipe"] = 1;
      data["callback"] = this.initData;
      if (!this.modal) {
        this.modal = {
          title: "Edit Topik",
          subtitle: "Silahkan masukan topik yang akan dimonitor",
          component: modal_edit_topic,
          data: data,
        };
      } else {
        this.modal = {
          title: "Edit Topik",
          subtitle: "Silahkan masukan topik yang akan dimonitor",
          component: modal_edit_topic,
          data: data,
        };
        this.modal_key++;
      }
    },
    addTopic: function() {
      if (!this.modal) {
        this.modal = {
          title: "Tambah Topik",
          subtitle: "Silahkan masukan topik yang akan dimonitor",
          component: modal_add_topic,
          data: [
            {
              tipe: 1,
              callback: this.initData,
            },
          ],
        };
      } else {
        this.modal = {
          title: "Tambah Topik",
          subtitle: "Silahkan masukan topik yang akan dimonitor",
          component: modal_add_topic,
          data: [
            {
              tipe: 1,
              callback: this.initData,
            },
          ],
        };
        this.modal_key++;
      }
    },
    deleteTopic: function(id) {
      let self = this;
      swal({
        title: "Apakah anda yakin?",
        text: "Akan menghapus Topik tersebut.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
      }).then((yess) => {
        if (yess) {
          let params = {
            _id: id,
            tipe: 1,
          };
          let api = self.api + "new-topic-delete";
          this.is_loading_float = true;
          this.$http
            .post(api, params)
            .then(function(response) {
              if (response.status == 200) {
                self.initData();
                self
                  .$("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Topik berhasil dihapus.',
                    position: "top",
                    timeout: 5000,
                    type: "success",
                  })
                  .show();
              } else {
                self
                  .$("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat menghapus topik.',
                    position: "top",
                    timeout: 5000,
                    type: "danger",
                  })
                  .show();
              }
            })
            .catch(function(error) {
              console.log(error);
              self
                .$("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat menghapus topik.',
                  position: "top",
                  timeout: 5000,
                  type: "danger",
                })
                .show();
            })
            .finally(() => {
              this.is_loading_float = false;
            });
        }
      });
    },
    generateTable: function(id, data) {
      if (this.isAdmin) {
        this.table = this.$(id).DataTable({
          destroy: true,
          data: data,
          language: {
            emptyTable: "Mohon maaf, data tidak tersedia!",
          },
          columns: [
            { data: "topic" },
            { data: "keyword" },
            { data: "excludes" },
            { data: "action" },
          ],
          columnDefs: [
            {
              render: function(data, type, row) {
                let btn =
                  '<center><button id="edit-keyword" class="btn btn-complete btn-sm m-r-5 ch" data-id="' +
                  row.topic_id +
                  '"><i class="bi bi-pencil-square"></i></button>';
                btn +=
                  '<button id="hapus-keyword" class="btn btn-danger btn-sm del" data-id="' +
                  row.topic_id +
                  '"><i class="bi bi-trash"></i></button></center>';
                return btn;
              },
              orderable: false,
              targets: 3,
            },
          ],
        });
      } else {
        this.table = this.$(id).DataTable({
          destroy: true,
          data: data,
          language: {
            emptyTable: "Mohon maaf, data tidak tersedia!",
          },
          columns: [
            { data: "topic" },
            { data: "keyword" },
            { data: "excludes" },
          ],
        });
      }
    },
    generateTableTopic: function(id, data) {
      let self = this;
      if (this.isAdmin) {
        this.table_topic = this.$(id).DataTable({
          destroy: true,
          data: data,
          language: {
            emptyTable: "Mohon maaf, data tidak tersedia!",
          },
          columns: [
            { data: "topic" },
            { data: "jumlah topik" },
            { data: "action", className: "td-actions" },
          ],
          columnDefs: [
            {
              render: function(data, type, row) {
                return row[1];
              },
              orderable: true,
              targets: 0,
            },
            {
              render: function(data, type, row) {
                let count = `<center>${self.showCount(row[1])}</center>`;
                return count;
              },
              orderable: true,
              targets: 1,
            },
            {
              render: function(data, type, row) {
                let btn =
                  '<center><button id="edit-topik" class="btn btn-warning btn-sm m-r-5 qr" data-id="' +
                  row[0] +
                  '"><i class="bi bi-database"></i></button> ';
                btn +=
                  '<button id="edit-topik" class="btn btn-complete btn-sm m-r-5 ch" data-id="' +
                  row[0] +
                  '"><i class="bi bi-pencil-square"></i></button> ';
                btn +=
                  '<button id="hapus-topik" class="btn btn-danger btn-sm del" data-id="' +
                  row[0] +
                  '"><i class="bi bi-trash"></i></button></center>';
                return btn;
              },
              orderable: false,
              targets: 2,
            },
          ],
        });
      } else {
        this.table_topic = this.$(id).DataTable({
          destroy: true,
          data: data,
          language: {
            emptyTable: "Mohon maaf, data tidak tersedia!",
          },
          columns: [{ data: "topic" }, { data: "jumlah topik" }],
          columnDefs: [
            {
              render: function(data, type, row) {
                return row[1];
              },
              orderable: false,
              targets: 0,
            },
            {
              render: function(data, type, row) {
                return self.showCount(row[1]);
              },
              orderable: false,
              targets: 1,
            },
          ],
        });
      }
    },
    initData: function() {
      this.getKeyword();
    },
    getProjectDetail: function() {
      let api =
        process.env.VUE_APP_API_URL + "project-detail/" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.$store.dispatch("user_project", response.data);

            this.project_detail = this.$store.getters.user.project.project_detail;
            this.keyword_terpakai = this.$store.getters.user.project.keyword_usage;
            this.keyword_display = {};
            this.keyword_display.persentase =
              this.keyword_terpakai > 0
                ? (this.keyword_terpakai / this.project_detail.keyword_limit) *
                  100
                : 0;

            if (this.keyword_display.persentase > 80) {
              this.keyword_display.class = "progress-bar-danger";
            } else {
              this.keyword_display.class = "progress-bar-success";
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    exportKeyword: function() {
      if (this.keywords) {
        var keyword_list = XLSX.utils.json_to_sheet(this.keywords);
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, keyword_list, "keywords");
        XLSX.writeFile(wb, "keyword_list.xlsx");
      } else {
        this.$("body")
          .pgNotification({
            style: "bar",
            message: '<i class="bi bi-x-circle"></i> Data Keyword Kosong!.',
            position: "top",
            timeout: 5000,
            type: "danger",
          })
          .show();
      }
    },
    showQuery: function(data) {
      const temp = {
        id: data[0],
        tipe: "medsos",
      };
      if (!this.modal) {
        this.modal = {
          title: `Query Topik "${data[1]}"`,
          subtitle:
            "Berikut merupakan query dari keyword pada topik yang dipilih",
          component: modal_query_topic,
          data: temp,
        };
      } else {
        this.modal = {
          title: `Query Topik "${data[1]}"`,
          subtitle:
            "Berikut merupakan query dari keyword pada topik yang dipilih",
          component: modal_query_topic,
          data: temp,
        };
        this.modal_key++;
      }
    },
    copyQuery: function() {
      if (this.keywords && this.keywords.length > 0 && this.user_role == 1) {
        let query =
          "python3 glavier_rapid_api_twitter_v2.py  --page 2 --keywords ";
        this.keywords.forEach((el) => {
          if (el.keyword.includes('"')) {
            const word = el.keyword.replace(/"/g, "");
            const key = `"\\"${word.trim()}"\\",`;
            query += key;
          } else {
            query += '"' + el.keyword.trim() + '",';
          }
        });
        query = query.slice(0, -1);
        navigator.clipboard.writeText(query).then(() => {
          this.is_copied = true;
          setTimeout(() => {
            this.is_copied = false;
          }, 3000);
        });
      }
    },
  },
  computed: {
    isAdmin: function() {
      let user_role = this.$store.getters.user.role;
      if (user_role == 1 || user_role == 2) {
        return true;
      }
      return false;
    },
  },
  created: function() {
    this.initData();
  },
  mounted: function() {
    let self = this;
    self.$("#daftar-keyword tbody").on("click", ".del", function() {
      var tr = self.$(this).closest("tr");
      var data = self.table.row(tr).data();
      self.deletekeyword(data.topic_id, data.keyword);
    });
    self.$("#daftar-keyword tbody").on("click", ".ch", function() {
      var tr = self.$(this).closest("tr");
      let id = self.$(tr).attr("id");
      var data = self.table.row(tr).data();
      self.editKeyword(id, data);
    });

    self.$("#daftar-topik tbody").on("click", ".qr", function() {
      var tr = self.$(this).closest("tr");
      var data = self.table_topic.row(tr).data();
      self.showQuery(data);
    });
    self.$("#daftar-topik tbody").on("click", ".del", function() {
      var tr = self.$(this).closest("tr");
      var data = self.table_topic.row(tr).data();
      self.deleteTopic(data[0]);
    });
    self.$("#daftar-topik tbody").on("click", ".ch", function() {
      var tr = self.$(this).closest("tr");
      var data = self.table_topic.row(tr).data();
      self.editTopic(data);
    });
    let v_step = [];
    v_step[0] = {
      target: "#tab-vertical",
      header: {
        title: "Tab Menu",
      },
      content: `Anda dapat memilih salah satu untuk melihat detail dari menu.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[1] = {
      target: "#tambah-topik",
      header: {
        title: "Tombol Tambah Topik",
      },
      content: `Klik untuk menambahkan data topik baru.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[2] = {
      target: "#daftar-topik_filter",
      header: {
        title: "Cari Item Tabel",
      },
      content: `Masukkan kata kunci untuk mencari topik yang diinginkan.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[3] = {
      target: "#daftar-topik",
      header: {
        title: "Tabel Topik",
      },
      content: `Menampilkan daftar topik tersedia.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[4] = {
      target: "#edit-topik",
      header: {
        title: "Tombol Edit Topik",
      },
      content: `Klik untuk mengedit topik yang dipilih.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[5] = {
      target: "#hapus-topik",
      header: {
        title: "Tombol Hapus Topik",
      },
      content: `Klik untuk menghapus topik yang dipilih.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[6] = {
      target: "#tambah-keyword",
      header: {
        title: "Tombol Tambah Keyword",
      },
      content: `Klik untuk menambah data keyword baru.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[7] = {
      target: "#export-keyword",
      header: {
        title: "Tombol Export Keyword",
      },
      content: `Klik untuk mengekspor data keyword tersedia ke dalam file excel.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[8] = {
      target: "#daftar-keyword_filter",
      header: {
        title: "Cari Item Tabel",
      },
      content: `Masukkan kata kunci untuk mencari keyword yang diinginkan.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[9] = {
      target: "#daftar-keyword",
      header: {
        title: "Daftar Keyword",
      },
      content: `Menampilkan daftar keyword tersedia.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[10] = {
      target: "#edit-keyword",
      header: {
        title: "Tombol Edit Keyword",
      },
      content: `Klik untuk mengedit keyword yang dipilih.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[11] = {
      target: "#hapus-keyword",
      header: {
        title: "Tombol Hapus Keyword",
      },
      content: `Klik untuk menghapus keyword yang dipilih.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };

    this.tour_steps = v_step;
  },
};
</script>

<style scoped>
.td-actions {
  text-overflow: clip !important;
}
</style>
